import { Link } from 'react-router-dom';
import type { LegalDocument } from './legalContent';
import { azaleaPath, SUPPORT_URL } from './constants';

function renderParagraph(text: string) {
  if (text.startsWith('http://') || text.startsWith('https://')) {
    return (
      <p key={text}>
        <a href={text} rel="noopener noreferrer" target="_blank">
          {text}
        </a>
      </p>
    );
  }
  return <p key={text}>{text}</p>;
}

function LegalRelatedLink({ docId }: { docId: string }) {
  if (docId !== 'privacy' && docId !== 'terms') return null;

  return (
    <p className="azalea-doc-related">
      {docId === 'privacy' ? (
        <>
          See also: <Link to={azaleaPath('terms')}>Terms of Use</Link>
        </>
      ) : (
        <>
          See also: <Link to={azaleaPath('privacy')}>Privacy Policy</Link>
        </>
      )}
    </p>
  );
}

export function AzaleaLegalDoc({ doc }: { doc: LegalDocument }) {
  return (
    <main className="azalea-main azalea-doc">
      <Link to={azaleaPath()} className="azalea-back-link">
        ← Back to Azalea
      </Link>

      <header className="azalea-doc-header">
        <h1>{doc.title}</h1>
        {doc.lastUpdated && (
          <p className="azalea-doc-updated">Last updated: {doc.lastUpdated}</p>
        )}
        <LegalRelatedLink docId={doc.id} />
      </header>

      {doc.sections.map((section, i) => (
        <section key={i} className="azalea-doc-section">
          {section.heading && <h2>{section.heading}</h2>}
          {section.paragraphs?.map(renderParagraph)}
          {section.bullets && (
            <ul>
              {section.bullets.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )}
        </section>
      ))}

      {doc.id === 'support' && (
        <p style={{ marginTop: 24 }}>
          <a
            href={SUPPORT_URL}
            className="azalea-btn-secondary"
            rel="noopener noreferrer"
            target="_blank"
          >
            Open support on GitHub
          </a>
        </p>
      )}

      {(doc.id === 'privacy' || doc.id === 'terms') && (
        <div className="azalea-doc-related" style={{ marginTop: 32 }}>
          <LegalRelatedLink docId={doc.id} />
        </div>
      )}
    </main>
  );
}
